import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
const Faq = () => {
  return (
    <div className="teams" id="faq">
      <div className="faqs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h4>Frequently Asked Questions</h4>
                <p>
                  If you can't find your question here, please feel free to
                  &nbsp; <Link to="">contact us.</Link>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 offset-lg-2 pt-5 pt-lg-0">
              <Accordion className="faq-accordion row">
                <div className="col-lg-12">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>What is ZForge?</Accordion.Header>
                    <Accordion.Body>
                      A: ZForge is a Play-to-Earn (P2E) game and metaverse where
                      players compete in a mythical arena as mortals chosen by
                      Greek Gods. It combines strategy, combat, and
                      blockchain-based rewards.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      How do I earn in ZForge?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: You can earn ZForge Tokens and NFTs by completing
                      quests, winning battles, staking tokens, and trading in
                      the marketplace.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      What makes ZForge unique?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: ZForge stands out with its AI-driven NPCs, personalized
                      gameplay, and a blend of mythological storytelling and
                      futuristic aesthetics. It also integrates blockchain for
                      true ownership of in-game assets.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      How are ZForge and ZFX tokens allocated?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: Tokenomics Breakdown:
                      <br />
                      <br />
                      $ZFORGE (Governance Token)
                      <br />
                      <br />
                      20% Public Sale
                      <br />
                      10% Ecosystem Fund & Liquidity
                      <br />
                      30% Staking Rewards
                      <br />
                      20% Pre-Sale
                      <br />
                      15% Team (3-year vesting)
                      <br />
                      5% Rewards & Incentives
                      <br />
                      <br />
                      $ZFX (In-Game Utility Token)
                      <br />
                      <br />
                      40% In-Game Rewards: Earned through gameplay.
                      <br />
                      20% Staking Rewards: Distributed to stakers over time.
                      <br />
                      15% Development Fund: Ongoing game improvements.
                      <br />
                      15% Marketing & Partnerships: Community growth.
                      <br />
                      10% Team & Advisors (3-year vesting).
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      What roles do ZForge and ZFX tokens play in the game's
                      ecosystem?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: ZForge features a carefully designed dual-token system:
                      <br /> $ZFORGE: Your voice in the metaverse! This
                      governance token enables staking rewards and DAO voting to
                      shape the game's future.
                      <br /> $ZFX: The lifeblood of gameplay! Earn this utility
                      token through quests and battles, then use it to upgrade
                      heroes, trade items, and unlock special features. years).
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      What blockchain does ZForge use?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: ZForge is built on Ethereum with Layer-2 solutions like
                      Polygon to ensure scalability and low transaction fees.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      How do I stake ZForge Tokens?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: Staking will be available through the ZForge platform
                      once the feature is live. Connect your wallet, choose the
                      amount to stake, and start earning rewards.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      How can I participate in the ZForge ICO?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: You can participate by purchasing ZForge Tokens during
                      the pre-sale or public sale using supported
                      cryptocurrencies or payment methods.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
